<template>
  <div>
    <div v-if="athlete === null">
      {{ textEmpty }}
    </div>
    <div v-else>
      <div v-if="athlete !== 'unassigned'">
        {{ textAthlete }}
        <b-button
          size="sm"
          variant="link"
          @click="remove"
        >Remove</b-button>
      </div>
      <div v-else class="d-flex">
        <b-button
          size="sm"
          variant="primary"
          @click="showModal = !showModal"
        >Assign</b-button>
      </div>
    </div>
    <b-modal
      v-model="showModal"
      :header-bg-variant="headerBg"
      header-text-variant="light"
      :title="'Assign ' + corner + ' corner'"
    >
      <p>
        {{ getClass(fight.classId).title }}<br>
        Fight number: {{ fight.nr }}<br>
      </p>
      <select class="custom-select" v-model="selectedAthlete">
        <option
          v-for="athlete in unassignedAthletes"
          :key="athlete.id"
          :value="athlete"
        >{{ athlete.name }} [{{ athlete.team }}]</option>
      </select>
      <template v-slot:modal-footer>
        <b-button :disabled="!selectedAthlete" variant="primary" @click="assign">Save</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'AthleteCell',
  props: ['fight', 'athlete', 'corner'],
  data() {
    return {
      selectedAthlete: null,
      showModal: false,
    };
  },
  methods: {
    assign() {
      this.$store.commit('assignAthleteToFight', {
        athlete: this.selectedAthlete,
        corner: this.corner,
        classId: this.fight.classId,
        fightId: this.fight.id,
      });
      this.selectedAthlete = null;
      this.showModal = false;
    },
    getClass(id) {
      return this.$store.state.setup.classes.find((c) => c.id === id);
    },
    remove() {
      this.$store.commit('pushUnassignedAthlete', {
        classId: this.fight.classId,
        athlete: this.athlete,
      });
      this.$store.commit('removeAthleteFromFight', {
        fightId: this.fight.id,
        corner: this.corner,
      });
    },
  },
  computed: {
    headerBg() {
      if (this.corner === 'red') return 'danger';
      return 'primary';
    },
    textAthlete() {
      if (this.athlete) return `${this.athlete.name} [${this.athlete.team}]`;
      return '';
    },
    textEmpty() {
      if (this.fight.nr === 1) return 'Winner Semi-Finals 1';
      if (this.fight.nr === 2) return 'Winner Quarter-Finals 1';
      if (this.fight.nr === 3) return 'Winner Quarter-Finals 3';
      return '';
    },
    unassignedAthletes() {
      return this.$store.state.setup.classes
        .find((c) => c.id === this.$store.state.setup.currentWeightClass).athletes;
    },
  },
  created() {
    if (this.athlete) this.athlete.selectString = `${this.athlete.name} [${this.athlete.team}]`;
  },
};
</script>

<style scoped>

</style>
